import React from 'react';

import { Column, Grid } from '@/components/global/Grid';
import { useSbImage } from '@/lib/hooks';

import { VideoPlayer } from './partials';
import { VideoHeroProps } from './types';
import styles from './VideoHero.module.scss';
import { VideoHeroProvider } from './VideoHeroProvider';

export const VideoHero: React.FC<VideoHeroProps> = ({
  video,
  poster,
  autoPlay = false,
  loop = false,
  footerChildren,
  videoUrl
}) => {
  const { getSbImage } = useSbImage();

  return (
    <VideoHeroProvider
      video={video}
      autoPlay={autoPlay}
      loop={loop}
      poster={poster}
      videoUrl={videoUrl}
    >
      <div className={styles.VideoHero}>
        <div className={styles.VideoHero__MobilePosterContainer}>
          <img
            style={{ display: 'none' }}
            src={getSbImage(poster?.filename, 800)}
            alt={poster?.alt}
          />
        </div>
        <div style={{ display: 'none' }} className={styles.VideoHero__VideoContainer}>
          <VideoPlayer />
        </div>
        <Grid className={styles.VideoHeroFooter}>
          <Column className={styles.VideoHeroFooter__inner} sm={12} md={12} lg={12}>
            {footerChildren.map((child) => (
              <div key={child.key}>{child}</div>
            ))}
          </Column>
        </Grid>
      </div>
    </VideoHeroProvider>
  );
};

export default VideoHero;
